import { render } from "./FileField.vue?vue&type=template&id=4ad25d4c&scoped=true"
import script from "./FileField.vue?vue&type=script&lang=js"
export * from "./FileField.vue?vue&type=script&lang=js"

import "./FileField.vue?vue&type=style&index=0&id=4ad25d4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad25d4c"]])

export default __exports__